import { Collapse } from '@chakra-ui/react'

export default Collapse
